import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Badge from 'react-bootstrap/Badge'
import { useSelector } from 'react-redux';

import './Home.css';
import { selectRider } from '../features/selectedRiderSlice';

import { useLocation } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();
  const selectedRider = useSelector(selectRider);
  let location = useLocation();

  useEffect(() => {
    if (selectedRider?.featuredTourId) {
      navigate(`/tours/${selectedRider.featuredTourId}`, { replace: true });
    }
  }, [selectedRider, navigate]);
  
  return (
    <Container>
      <div className='mb-2'>
        Welcome to the Touring app. I use this app to share my adventures with the world. 
        Tour and Ride information comes from a native iOS app that I use to track my rides. 

        <div className='mt-3'>
          Browse the tours and rides.
        </div>
      </div>
      {location.state && <div className='mb-2'><Badge bg='danger'>{location.state.message}</Badge></div>}
      {!selectedRider && <div>Loading featured tour...</div>}
    </Container>
  );
}

export default Home;